import { render } from "./AdConsult.vue?vue&type=template&id=55c68ae2&scoped=true"
import script from "./AdConsult.vue?vue&type=script&lang=js"
export * from "./AdConsult.vue?vue&type=script&lang=js"

import "./AdConsult.vue?vue&type=style&index=0&id=55c68ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c68ae2"]])

export default __exports__